<template>
  <!-- reCAPTCHA v3 não renderiza nenhum widget visível -->
  <div></div>
</template>

<script>
export default {
  name: "Recaptcha",
  props: {
    siteKey: {
      type: String,
      required: true,
    },
  },
  methods: {
    /**
     * Executa o reCAPTCHA v3 em background (sem interação do usuário).
     * @param {string} action - Nome da ação para análise (ex: 'search', 'contact')
     * @returns {Promise<string>} Token gerado pelo reCAPTCHA
     */
    execute(action = 'submit') {
      return new Promise((resolve, reject) => {
        if (typeof grecaptcha === 'undefined') {
          // Se o script não carregou, permite continuar sem bloquear o usuário
          resolve('unavailable');
          return;
        }
        grecaptcha.ready(() => {
          grecaptcha
            .execute(this.siteKey, { action })
            .then(resolve)
            .catch(reject);
        });
      });
    },
  },
};
</script>
